import axios from 'axios';
import { children, createContext, useContext, useState ,useEffect} from 'react';
import config from "../config";
 
const ValidationContext = createContext();

export const useValidation = () => useContext(ValidationContext);

export const ValidationProvider = ({ children }) => {
const [isValidated, setIsValidated] = useState(false);
const [selectedTable, setSelectedTable] = useState(0);
const [currency, setCurrency] = useState('MYR');
const apiBaseUrl = config.REACT_APP_API_BASE_URL;
const updateValidation = (validation, table) => {
    setIsValidated(validation);
    setSelectedTable(table);
};

    const getCurrencySetting = async () =>{
        const { data } = await axios.get(`${apiBaseUrl}/api/settings/get-settings`);
        updateCurrency(data.currencyCode);
    }
    
    // Load saved currency from localStorage on initial load
    useEffect( () => {
        if(localStorage.getItem('currency') == null){
            const savedCurrency = getCurrencySetting();
            setCurrency(savedCurrency);
        }else{
            const savedCurrency = localStorage.getItem('currency');
            setCurrency(savedCurrency);
        }
       
    }, []);

        // Update both state and localStorage when currency changes
    const updateCurrency = (newCurrency) => {
        console.log(newCurrency);
        localStorage.setItem('currency', newCurrency);
        setCurrency(newCurrency);
    };

return (
    <ValidationContext.Provider value={{ isValidated, selectedTable, updateValidation, currency, updateCurrency }}>
    {children}
    </ValidationContext.Provider>
);

};

export const useCurrency = () => useContext(ValidationContext);
